import { useState } from "react";
import { ArrowRight, Plus, X } from "lucide-react";
import { rooms } from "@/data";

const MAX_GUESTS_PER_ROOM = 3;
const GUEST_OPTIONS = Array.from({ length: MAX_GUESTS_PER_ROOM }, (_, i) => i + 1);

function guestOptionLabel(n) {
  return n > 1 ? `${n} guests` : `${n} guest`;
}

function roomHeading(index) {
  return `Room ${index + 1}`;
}

/**
 * Check-in/out + a dynamic list of rooms — each with its own guest
 * count (capped at 3) and room category — with an "Add another room"
 * control, same pattern as any hotel OTA.
 */
export default function BookingFields({ onSubmit, idPrefix }) {
  const [roomEntries, setRoomEntries] = useState([{ guests: 2, roomType: "Any room" }]);

  const addRoom = () =>
    setRoomEntries((entries) => [...entries, { guests: 2, roomType: "Any room" }]);
  const removeRoom = (index) => setRoomEntries((entries) => entries.filter((_, i) => i !== index));
  const setGuestsFor = (index, value) =>
    setRoomEntries((entries) => entries.map((e, i) => (i === index ? { ...e, guests: value } : e)));
  const setRoomTypeFor = (index, value) =>
    setRoomEntries((entries) => entries.map((e, i) => (i === index ? { ...e, roomType: value } : e)));

  const multiRoom = roomEntries.length > 1;

  return (
    <form className="booking-fields" onSubmit={onSubmit}>
      <label>
        Check in <input type="date" data-testid={`${idPrefix}-checkin`} />
      </label>
      <label>
        Check out <input type="date" data-testid={`${idPrefix}-checkout`} />
      </label>

      <div className="booking-rooms">
        {roomEntries.map((entry, i) => (
          <div className="booking-room-row" key={i}>
            {multiRoom && (
              <div className="booking-room-heading">
                <span>{roomHeading(i)}</span>
                <button
                  type="button"
                  className="booking-room-remove"
                  onClick={() => removeRoom(i)}
                  aria-label={`Remove room ${i + 1}`}
                >
                  <X size={14} />
                </button>
              </div>
            )}
            <div className="booking-room-fields">
              <label>
                Guests
                <select
                  value={entry.guests}
                  onChange={(e) => setGuestsFor(i, Number(e.target.value))}
                  data-testid={`${idPrefix}-guests-${i}`}
                >
                  {GUEST_OPTIONS.map((n) => (
                    <option key={n} value={n}>
                      {guestOptionLabel(n)}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Room
                <select
                  value={entry.roomType}
                  onChange={(e) => setRoomTypeFor(i, e.target.value)}
                  data-testid={`${idPrefix}-room-type-${i}`}
                >
                  <option>Any room</option>
                  {rooms.map((r) => (
                    <option key={r.name}>{r.name}</option>
                  ))}
                </select>
              </label>
            </div>
          </div>
        ))}
      </div>

      <button type="button" className="booking-add-room" onClick={addRoom} data-testid={`${idPrefix}-add-room`}>
        <Plus size={14} /> Add another room
      </button>

      <button type="submit" className="btn btn-primary btn-full" data-testid={`${idPrefix}-search`}>
        Check availability <ArrowRight size={15} />
      </button>
    </form>
  );
}
